import { Star, Heart, Crown, Calendar, Disc, Shuffle, CloudRain } from 'lucide-react';

export const CONQUISTA_ICON_MAP: Record<string, typeof Star> = {
  Star, Heart, Crown, Calendar, Disc, Shuffle, HeartPink: Heart, CloudRain,
};
